import file from "/libs/json/CourseClassification.json"
const items = JSON.parse(JSON.stringify(file))

function handler(value) {
  return items.find(o => o.value == value)?.text || ''
}
export default handler